export default "__VITE_ASSET__a9dcc39e__"